import { mutation, query } from "@core/helpers/graphql";
import {
  GET_COMMENTS,
  GET_COMMENTS_BY_MOCKUP,
  GET_COMMENTS_WITH_REPLIES,
  GET_USER_COMMENTS,
  GET_USER_COMMENTS_MODEL,
} from "./_queries";
import { ADD_TO_USEFUL_COMMENTS, CREATE_COMMENT, DELETE_COMMENT, REPLY_COMMENT } from "./_mutations";

export const get_model_comments = async (variables, options = {}) => {
  const { gql, comments_mockup } = options;
  const result = await query(gql || (comments_mockup ? GET_COMMENTS_BY_MOCKUP(comments_mockup) : GET_COMMENTS), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_model_comments_with_replies = async (variables, options = {}) => {
  const { gql, comments_mockup } = options;
  const result = await query(gql || (comments_mockup ? GET_COMMENTS_BY_MOCKUP(comments_mockup) : GET_COMMENTS_WITH_REPLIES), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_model_user_comments = async (variables, options = {}) => {
  const { gql } = options;
  const result = await query(
    gql || GET_USER_COMMENTS_MODEL,
    variables,
    options
  );
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_user_comments = async (variables, options = {}) => {
  const { gql, custom_gql } = options;
  const result = await query(gql || GET_USER_COMMENTS(custom_gql), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const create_comment_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || CREATE_COMMENT, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const reply_comment_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || REPLY_COMMENT, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};
export const add_to_useful_comments_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || ADD_TO_USEFUL_COMMENTS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const delete_comment_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || DELETE_COMMENT, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};
